/* global angular, $ */
angular.module('ua5App')
    .directive('overlay', ['$state', '$rootScope', function($state, $rootScope) {
        return {
            restrict: 'A',
            scope: {
                closeSelector: '@'
            },
            link: function($scope, $element, $attrs) {
                $scope.$on('app:escapePressed', function() {
                    if (!$rootScope.modalOpen) {
                        $state.go('index');
                    }
                });
                $element.on('click', function(e) {
                    $scope.closeSelector = $scope.closeSelector || '.overlay__content';
                    if ($(e.target).is($scope.closeSelector)) {
                        $state.go('index');
                    }
                });
            }
        };
    }])
;
